document.addEventListener('DOMContentLoaded', () => {
  // Debounce mechanism to prevent double alerts
  let lastAlertTime = 0;
  const ALERT_DEBOUNCE_MS = 1000; // Prevent duplicate alerts within 1 second

  // Function to get the checkbox (handles both regular cart and cart drawer)
  function getAgreeCheckbox() {
    // Try multiple selectors to find the checkbox
    return document.getElementById('agree') || 
           document.querySelector('input[type="checkbox"]#agree') ||
           document.querySelector('input[name="agree"]') ||
           document.querySelector('.cart-drawer input[type="checkbox"]');
  }

  // Function to check if terms are accepted
  function areTermsAccepted() {
    const checkbox = getAgreeCheckbox();
    if (!checkbox) {
      return true; // If no checkbox exists, don't block checkout
    }
    
    return checkbox.checked;
  }

  // Function to show alert with debounce protection
  function showTermsAlert() {
    const now = Date.now();
    if (now - lastAlertTime < ALERT_DEBOUNCE_MS) {
      return;
    }
    
    lastAlertTime = now;
    const message = (window.Shopify && window.Shopify.translations && window.Shopify.translations.cartAcceptTerms) 
                   || 'Please accept the terms and conditions to continue.';
    alert(message);
    
    // Focus and scroll to checkbox
    const checkbox = getAgreeCheckbox();
    if (checkbox) {
      checkbox.focus();
      checkbox.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  // Enhanced checkout button selectors
  const CHECKOUT_SELECTORS = [
    '[name="checkout"]',
    '[type="submit"][name="checkout"]',
    'button[name="checkout"]',
    '[name="goto_pp"]',
    '[name="goto_gc"]',
    'a[href*="/checkout"]',
    '.checkout-button',
    '.btn-checkout',
    '[data-checkout]'
  ].join(',');

  // Main click handler
  document.body.addEventListener('click', (e) => {
    const clickedElement = e.target.closest(CHECKOUT_SELECTORS);
    
    if (!clickedElement) {
      return; // Not a checkout button
    }
    
    if (!areTermsAccepted()) {
      e.preventDefault();
      e.stopImmediatePropagation();
      showTermsAlert();
      return false;
    }
  }, { capture: true });

  // Form submit handler with better form detection
  function addFormSubmitHandler() {
    // Find all possible cart forms
    const forms = [
      document.getElementById('cart'),
      document.querySelector('form[action*="/cart"]'),
      document.querySelector('.cart-drawer form'),
      document.querySelector('form[action*="checkout"]'),
      ...document.querySelectorAll('form')
    ].filter(form => form && (
      form.action.includes('/cart') || 
      form.action.includes('/checkout') ||
      form.querySelector('[name="checkout"]')
    ));

    forms.forEach(form => {
      form.addEventListener('submit', (e) => {
        // Check if this form has a checkout button
        const hasCheckoutButton = form.querySelector(CHECKOUT_SELECTORS);
        if (!hasCheckoutButton) {
          return; // Not a checkout form
        }

        if (!areTermsAccepted()) {
          e.preventDefault();
          e.stopImmediatePropagation();
          showTermsAlert();
          return false;
        }
      }, { capture: true });
    });
  }

  // Initial form handler setup
  addFormSubmitHandler();

  // Re-run form handler setup when DOM changes (for AJAX cart updates)
  const observer = new MutationObserver((mutations) => {
    let shouldRecheck = false;
    
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) { // Element node
            if (node.matches && (
                node.matches('form') || 
                node.matches('.cart-drawer') ||
                node.querySelector && node.querySelector('form')
            )) {
              shouldRecheck = true;
            }
          }
        });
      }
    });

    if (shouldRecheck) {
      setTimeout(addFormSubmitHandler, 100);
    }
  });

  // Observe the entire document for changes
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Additional: Track checkbox state changes
  const initialCheckbox = getAgreeCheckbox();
  if (initialCheckbox) {
    initialCheckbox.addEventListener('change', (e) => {
      // Checkbox state changed
    });
  }
});